import { render, staticRenderFns } from "./SubmitProteinBlock.vue?vue&type=template&id=1e18978a&scoped=true&"
import script from "./SubmitProteinBlock.vue?vue&type=script&lang=js&"
export * from "./SubmitProteinBlock.vue?vue&type=script&lang=js&"
import style0 from "./SubmitProteinBlock.vue?vue&type=style&index=0&id=1e18978a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e18978a",
  null
  
)

export default component.exports